'use client'

import React from 'react'
import { cn } from '../lib/cn'

interface RadarProps {
  className?: string
  size?: number
}

/**
 * Animated radar component with pulsing concentric circles and rotating sweep line.
 */
export const Radar: React.FC<RadarProps> = ({ className, size = 400 }) => {
  return (
    <div className={cn('relative flex items-center justify-center', className)}>
      <div
        className="relative"
        style={{
          width: `${size}px`,
          height: `${size}px`,
        }}
      >
        {/* Concentric circles - middle + 5 rings of equal perceived width */}
        {/* Outer ring (5th) - Tea */}
        <div
          className="absolute rounded-full"
          style={{
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: `${size}px`,
            height: `${size}px`,
            backgroundColor: 'var(--tea)',
            opacity: 1,
          }}
        />
        {/* 4th ring - Strong Tea */}
        <div
          className="absolute rounded-full"
          style={{
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: `${size * 0.8}px`,
            height: `${size * 0.8}px`,
            backgroundColor: 'var(--stronger-tea)',
            opacity: 1,
          }}
        />
        {/* 3rd ring - Tiffany */}
        <div
          className="absolute rounded-full"
          style={{
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: `${size * 0.6}px`,
            height: `${size * 0.6}px`,
            backgroundColor: 'var(--tiffany)',
            opacity: 1,
          }}
        />
        {/* 2nd ring - Blue Grey 
        <div
          className="absolute rounded-full"
          style={{
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: `${size * 0.4}px`,
            height: `${size * 0.4}px`,
            backgroundColor: 'var(--blue-grey)',
            opacity: 1,
          }}
        />*/}
        {/* 1st ring (wraps middle) - Sky Blue */}
        <div
          className="absolute rounded-full"
          style={{
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: `${size * 0.4}px`,
            height: `${size * 0.4}px`,
            backgroundColor: 'var(--sky-blue)',
            opacity: 1,
          }}
        />
        {/* Center circle (middle) - Blue Grey */}
        <div
          className="absolute rounded-full"
          style={{
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: `${size * 0.2}px`,
            height: `${size * 0.2}px`,
            backgroundColor: 'var(--blue-grey)',
            opacity: 1,
          }}
        />

        {/* Pulsing rings */}
        <div
          className="absolute"
          style={{
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            borderRadius: '50%',
            border: '2px solid var(--blue-grey)',
            opacity: 0.6,
            width: '40px',
            height: '40px',
            animation: 'pulse-out 5s ease-out infinite 0s',
          }}
        />
        <div
          className="absolute"
          style={{
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            borderRadius: '50%',
            border: '2px solid var(--blue-grey)',
            opacity: 0.6,
            width: '40px',
            height: '40px',
            animation: 'pulse-out 5s ease-out infinite 1.67s',
          }}
        />
        <div
          className="absolute"
          style={{
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            borderRadius: '50%',
            border: '2px solid var(--blue-grey)',
            opacity: 0.6,
            width: '40px',
            height: '40px',
            animation: 'pulse-out 5s ease-out infinite 3.34s',
          }}
        />

        {/* Sweep line */}
        <div
          className="absolute"
          style={{
            top: '50%',
            left: '50%',
            width: '2px',
            height: `${size * 0.5}px`,
            background: 'linear-gradient(to bottom, rgba(255, 255, 255, 0.9), transparent)',
            transformOrigin: 'top center',
            transform: 'translate(-50%, 0) rotate(0deg)',
            animation: 'radar-rotate 4s linear infinite',
            filter: 'drop-shadow(0 0 4px rgba(255, 255, 255, 0.6))',
          }}
        />
      </div>
    </div>
  )
}

